import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const UsageScreenContext = /*#__PURE__*/createContext(undefined);
export function UsageScreenProvider({
  children,
  screen,
  subscreen
}) {
  return /*#__PURE__*/_jsx(UsageScreenContext.Provider, {
    value: {
      screen,
      subscreen
    },
    children: children
  });
}